import { AgentAvatar } from "@/components/molecules/agent-avatar";
import { cn } from "@/lib/utils";
import { Bubble, BubbleRow, TypingDots } from "./Bubble";

interface TypingIndicatorProps {
  agentName?: string;
  agentLogo?: string | null;
  /**
   * Whether the bubble should be showing. It is always mounted: unmounting it the
   * instant the first chunk arrives removed its height in one frame and snapped the
   * whole thread downwards. Kept in the tree, it collapses (0fr grid row + fade) on the
   * way out, so the messages slide instead of jumping.
   */
  show?: boolean;
}

// Three-dot "assistant is typing" bubble shown while we wait for the first streamed
// chunk — the agent bubble itself, so the answer takes its place without a reshape.
export function TypingIndicator({
  agentName,
  agentLogo,
  show = true,
}: TypingIndicatorProps) {
  return (
    <div
      aria-hidden={!show}
      className={cn(
        // `my-0!` because the collapsed state must take no room at all — the parent's
        // space-y margin would otherwise stay behind as a phantom gap. The spacing when
        // shown comes from the padding inside instead.
        "grid my-0! transition-all duration-200 ease-out motion-reduce:transition-none",
        show ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
      )}
    >
      <div className="overflow-hidden">
        <BubbleRow
          side="agent"
          className="pt-4"
          avatar={
            <AgentAvatar
              name={agentName}
              logo={agentLogo}
              className="mb-1 size-7"
            />
          }
        >
          <Bubble side="agent">
            <TypingDots />
          </Bubble>
        </BubbleRow>
      </div>
    </div>
  );
}
